import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const retailerCollectionsV3AccessControl: DomainAccessControlConfig = {
  permissions: [
    Permission.RetailerCollectionsRetailerCollectionsV2,
    Permission.CatalogProductsView,
  ],
  restrictedBannersAllowed: true,
}
